"use client";
import {useEffect, useRef} from 'react';
import {watchFooterContrast} from './dgroupContrast';
export default function DaqinixGroupCredit(){
  const root=useRef(null);
  useEffect(()=>root.current ? watchFooterContrast(root.current) : undefined,[]);
  return <div className="dgroup-credit" ref={root} style={{'--dgroup-mask':"url('/dgrouporiginal2.png')"}}><a href="https://daqinix.com" target="_blank" rel="noopener noreferrer" aria-label="A Daqinix Group Original Project — visit Daqinix"><span className="dgroup-credit__mark" aria-hidden="true" /></a></div>;
}
